<div class="card">
  <video #videoElement muted autoplay [width]="width" [height]="height"></video>
  <canvas #canvasElement style="display: none"></canvas>
  <div class="error" *ngIf="error">
    Nepodařilo se spustit kameru!
  </div>
</div>
